import { render, staticRenderFns } from "./selectStock.vue?vue&type=template&id=20f3ad45&scoped=true&"
import script from "./selectStock.vue?vue&type=script&lang=js&"
export * from "./selectStock.vue?vue&type=script&lang=js&"
import style0 from "./selectStock.vue?vue&type=style&index=0&id=20f3ad45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3ad45",
  null
  
)

export default component.exports